export const CONSENT_COOKIE_NAME = "cookie_consent";
